function getInitialTokenState() {
  const isDevelopment = process.env.VUE_APP_ENV === 'local' && window.location.hostname === 'localhost';

  if (!isDevelopment) {
    return {
      token: null,
      tokenTimestamp: null,
      userId: null,
    };
  }

  const localToken = localStorage.getItem('token');
  const localTimestamp = localStorage.getItem('tokenTimestamp');
  const localUserId = localStorage.getItem('userId');

  if (localToken && localTimestamp && localUserId) {
    console.info('Restoring authentication state from localStorage (development/testing mode)');
    return {
      token: localToken,
      tokenTimestamp: localTimestamp,
      userId: localUserId,
    };
  }

  return {
    token: null,
    tokenTimestamp: null,
    userId: null,
  };
}

const initialTokenState = getInitialTokenState();

export default {
  status: '',
  token: initialTokenState.token,
  originalToken: null,
  user: {},
  tokenTimestamp: initialTokenState.tokenTimestamp,
  isApiKey: false,
  isImpersonating: false,
  access: [],
  primaryScopeIds: [],
  primaryTenantIds: [],
  tenantId: null,
  tenantIdThemeSetting: null,
  hasCredentials: !!initialTokenState.token,
  userId: initialTokenState.userId,
};
